// extracted by mini-css-extract-plugin
module.exports = {"filters":"VerticalList_filters__Q4MqE","wrapper":"VerticalList_wrapper__JTotL","list":"VerticalList_list__IuYYX"};